module.exports = "/assets/discount.png?I1SywXU";